<template>
  <div style="position: relative;">
    <div
      class="bubble"
      :style="{ width: size + 'px', height: size + 'px', lineHeight: size + 'px' }"
    >
      {{ number }}
    </div>
    <div class="version-code">{{ version | format }}</div>
    <div class="value-div">
      <span class="progress">{{ progress }}%</span>
      <span class="label">日</span>
      <span class="value" :class="{ up: dayNumber > 0, down: dayNumber < 0 }"
        >{{ Math.abs(dayNumber) }}台</span
      >
      <svg class="icon down" aria-hidden="true" v-if="dayNumber < 0">
        <use xlink:href="#icon-triangle"></use>
      </svg>
      <svg class="icon up" aria-hidden="true" v-if="dayNumber > 0">
        <use xlink:href="#icon-triangle"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/utils'
export default {
  name: 'Bubble',
  filters: {
    format
  },
  props: {
    size: {
      type: Number
    },
    number: {
      type: Number,
      default: 0
    },
    version: {
      type: String
    },
    progress: {
      type: Number,
      default: 0
    },
    dayNumber: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.bubble {
  margin: 0 auto;
  font-family: Barlow-SemiBold;
  font-size: 32px;
  font-weight: 600;
  color: #339dff;
  text-align: center;
  background-image: url('../../../assets/bubble.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.version-code {
  margin: 8px auto 4px;
  line-height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  text-align: center;
}
.value-div {
  margin: 0 auto;
  line-height: 22px;
  font-size: 14px;
  text-align: center;
  .progress {
    margin-right: 6px;
    color: #666666;
    font-weight: 600;
  }
  .label {
    color: #999999;
  }
  .value {
    color: #666666;
    font-weight: 600;
    &.up {
      color: #ec6161;
    }
    &.down {
      color: #00cbd3;
    }
  }
  .icon {
    line-height: 22px;
    font-size: 14px;
    &.up {
      color: #ec6161;
      transform: scale(1, -1);
    }
    &.down {
      color: #00cbd3;
    }
  }
}
</style>
